<template>
    <div class="scaling-header">
        <div class="scaling-header__label">
            <span class="scaling-header__label__text">Scaled to</span><span>{{ userVisibleScalingPercentage }}%</span>
        </div>
        <Tooltip placement="left" :transfer="true">
            <hox-square-button @click="toggleScaling">
                <Icon size="24" :type="scalingButtonIcon" />
            </hox-square-button>
            <template #content>
                <template v-if="isScaled">Show original size</template>
                <template v-else>Scale to fit</template>
            </template>
        </Tooltip>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { useGA4Tracking } from "@/composables/useGA4Tracking";
import GA4 from "@/enums/ga4Events";

export default defineComponent({
    name: "ScalingHeader",

    props: {
        internalScalingFactor: {
            type: Number,
            required: true
        },
        isScaled: {
            type: Boolean,
            required: true
        }
    },

    emits: ["toggleScaling"],

    setup() {
        const ga4 = useGA4Tracking();

        return {
            ga4
        };
    },

    computed: {
        scalingButtonIcon() {
            return this.isScaled ? "ios-expand" : "ios-contract";
        },

        userVisibleScalingPercentage() {
            return Math.round(this.internalScalingFactor * 100);
        }
    },

    methods: {
        toggleScaling() {
            const clickEventText = this.isScaled ? "Show original size" : "Scale to fit";
            this.ga4.trackClickEvent({
                interactionObject: GA4.CLICK_INTERACTION_OBJECTS.BUTTON,
                interactionText: clickEventText
            });
            this.$emit("toggleScaling");
        }
    }
});
</script>

<style lang="scss" scoped>
.scaling-header {
    flex-grow: 1;

    display: flex;
    align-items: center;
    justify-content: flex-end;

    container-type: inline-size;
}
.scaling-header__label {
    display: flex;
    gap: 4px;

    @container (width < 70px) {
        display: none;
    }
}

.scaling-header__label__text {
    @container (width < 130px) {
        display: none;
    }
}
</style>
